module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['hold-transition', 'layout-top-nav', _vm.jeAdmin ? 'skin-blue' : 'skin-green']
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('header', {
    staticClass: "main-header"
  }, [_c('nav', {
    staticClass: "navbar navbar-inverse"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.homeButton()
      }
    }
  }, [_vm._v("\n              e"), _c('b', [_vm._v("Q")]), _vm._v("uiz\n            ")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navbar-collapse"
    }
  }, [(!_vm.isSimpleHeader && !_vm.jeAdmin) ? _c('ul', {
    staticClass: "nav navbar-nav"
  }, [(!_vm.selectedGroupId) ? _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.s()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('header.groups')))])]) : _vm._e(), _vm._v(" "), (_vm.selectedGroupId && _vm.selectedGroup) ? _c('li', {
    staticClass: "dropdown active"
  }, [(_vm.selectedGroup.group) ? _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm._f("pickTranslation")(_vm.selectedGroup.group.name)) + "\n                    "), _c('span', {
    staticClass: "fa fa-caret-down"
  })]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.goToExercises()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('header.exercises')))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.goToProgress()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('header.progress')))])]), _vm._v(" "), _c('li', {
    staticClass: "divider"
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.leaveGroup()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('header.leave')))])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isSimpleHeader && _vm.jeAdmin) ? _c('ul', {
    staticClass: "nav navbar-nav"
  }, [(!_vm.selectedGroupId) ? _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.s()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.group.bannerName')))])]) : _vm._e(), _vm._v(" "), (_vm.selectedGroupId && _vm.selectedGroup.group) ? _c('li', {
    staticClass: "dropdown active"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm._f("pickTranslation")(_vm.selectedGroup.group.name)) + "\n                    "), _c('span', {
    staticClass: "fa fa-caret-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.goToExercises()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('header.exercises')))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.goToClasses()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('header.classes')))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.$t('header.statistics')) + "\n                        "), _vm._m(1)]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "divider"
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.goToPanel()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('header.panel')))])]), _vm._v(" "), _c('li', {
    staticClass: "divider"
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.leaveGroup()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('header.leave')))])])])]) : _vm._e(), _vm._v(" "), (_vm.selectedGroupId) ? _c('li', {
    staticClass: "dropdown active"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_vm._v(_vm._s(_vm.selectedYear.name) + "\n                    "), _c('span', {
    staticClass: "fa fa-caret-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, _vm._l((_vm.selectedGroup.years), function(year) {
    return _c('li', {
      key: year.id
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.changeYear(year)
        }
      }
    }, [_vm._v(_vm._s(year.name))])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToLibrary()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('header.library')))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToUsers()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('header.users')))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToTablets()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('header.tablets')))])])]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [(!_vm.isSimpleHeader && _vm.jeAdmin && !_vm.isCollapsed()) ? _c('li', {
    staticClass: "dropdown notifications-menu",
    on: {
      "click": function($event) {
        return _vm.updateReports()
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v(_vm._s(_vm.$t('header.reportsStart')) + " " + _vm._s(_vm.pendingReports.length) + " " + _vm._s(_vm.$t('header.reportsEnd')))]), _vm._v(" "), _c('li', {
    staticClass: "footer"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'reports'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-users text-aqua"
  }), _vm._v(" " + _vm._s(_vm.$t('header.reportsView')) + "\n                      ")])], 1)])]) : _vm._e(), _vm._v(" "), (!_vm.isSimpleHeader && _vm.jeAdmin && _vm.isCollapsed()) ? _c('li', {
    staticClass: "dropdown notifications-menu",
    on: {
      "click": function($event) {
        return _vm.updateReports()
      }
    }
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('header.reports')) + "\n                  ")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    staticStyle: {
      "width": "auto"
    }
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v(_vm._s(_vm.$t('header.reportsStart')) + " " + _vm._s(_vm.pendingReports.length) + " " + _vm._s(_vm.$t('header.reportsEnd')))]), _vm._v(" "), _c('li', {
    staticClass: "footer"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'reports'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-users text-aqua"
  }), _vm._v(" " + _vm._s(_vm.$t('header.reportsView')) + "\n                      ")])], 1)])]) : _vm._e(), _vm._v(" "), (!_vm.isSimpleHeader && !_vm.isCollapsed()) ? _c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "aria-expanded": "true"
    }
  }, [(!_vm.isCollapsed()) ? _c('img', {
    staticClass: "user-image",
    attrs: {
      "src": _vm.profilePicture,
      "alt": "User Image"
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {}, [_vm._v(_vm._s(_vm.userLoggedIn))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "user-header"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": _vm.profilePicture,
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n                        " + _vm._s(_vm.userLoggedIn) + "\n                      ")])]), _vm._v(" "), _c('li', {
    staticClass: "user-footer"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('a', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToProfile(_vm.userId)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.userIconInHeader.profile')))])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [(!_vm.isSimpleHeader) ? _c('a', {
    staticClass: "btn btn-default btn-flat",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logout($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.userIconInHeader.signOut')))]) : _c('a', {
    staticClass: "btn btn-default btn-flat",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logout($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.userIconInHeader.pleaseLogin')))])])])])]) : _vm._e(), _vm._v(" "), (!_vm.isSimpleHeader && _vm.isCollapsed()) ? _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.goToProfile(_vm.userId)
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.userLoggedIn) + " (" + _vm._s(_vm.$t('pages.userIconInHeader.profile')) + ")")])])]) : _vm._e(), _vm._v(" "), (!_vm.isSimpleHeader && _vm.isCollapsed()) ? _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('pages.userIconInHeader.signOut')))])])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "dropdown tasks-menu"
  }, [_vm._m(3), _vm._v(" "), (!_vm.isCollapsed()) ? _c('ul', {
    staticClass: "dropdown-menu",
    staticStyle: {
      "width": "11em"
    }
  }, [_c('li', [_c('ul', {
    staticClass: "menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeLocale('sl')
      }
    }
  }, [_c('h3', [_c('i', {
    staticClass: "fa fa-flag"
  }), _vm._v("\n                              " + _vm._s(_vm.$t("header.langSlo")) + "\n                            ")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeLocale('en')
      }
    }
  }, [_c('h3', [_c('i', {
    staticClass: "fa fa-flag"
  }), _vm._v("\n                              " + _vm._s(_vm.$t("header.langEng")) + "\n                            ")])])])])])]) : _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeLocale('sl')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-flag"
  }), _vm._v("\n                          " + _vm._s(_vm.$t("header.langSlo")) + "\n                      ")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeLocale('en')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-flag"
  }), _vm._v("\n                          " + _vm._s(_vm.$t("header.langEng")) + "\n                      ")])])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper",
    class: {
      'auth-wrapper': _vm.isAuthScreen
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    key: _vm.kljuc,
    staticClass: "breadcrumbs"
  }, [_c('breadcrumbs')], 1), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('router-view')], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbar-collapse"
    }
  }, [_c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right-container"
  }, [_c('small', {
    staticClass: "label pull-right bg-blue"
  }, [_vm._v("?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-flag"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "aria-expanded": "true"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-globe"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-21c62a07", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21c62a07"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/header.vue
// module id = 1388
// module chunks = 1